import { HttpInterceptorFn } from '@angular/common/http';

/**
 * HTTP Interceptor to add common headers to all requests
 */
export const headersInterceptor: HttpInterceptorFn = (req, next) => {  // Skip Content-Type header for FormData (multipart/form-data)
  // The browser will set the correct Content-Type with boundary automatically
  if (req.body instanceof FormData) {
    const clonedRequest = req.clone({
      setHeaders: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    return next(clonedRequest);
  }
  const clonedRequest = req.clone({
    setHeaders: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  return next(clonedRequest);
};
